import { createUiBindings } from '@ff-scene-plugins/photo-prints-redux/slices/generalUiSlice';

const { createSelector, createUpdateAction } = createUiBindings();

export const selectIsPhotoPrintsWindowOpen = createSelector(state => state.isPhotoPrintsWindowOpen);
export const setIsPhotoPrintsWindowOpen = createUpdateAction('isPhotoPrintsWindowOpen');

export const selectShowProjectIsIncompatible = createSelector(state => state.showProjectIncompatible);
export const setShowProjectIsIncompatible = createUpdateAction('showProjectIncompatible');

export const selectisFotofunPanelOpen = createSelector(state => state.isFotofunPanelOpen);
export const setisFotofunPanelOpen = createUpdateAction('isFotofunPanelOpen');

export const selectIsFotofunBannerHidden = createSelector(state => state.isFotofunBannerHidden);
export const setIsFotofunBannerHidden = createUpdateAction('isFotofunBannerHidden');

export const selectFotoFunTab = createSelector(state => state.fotoFunTab);
export const setFotoFunTab = createUpdateAction('fotoFunTab');

export const selectFrameId = createSelector(state => state.frameIdMobile);
export const setFrameId = createUpdateAction('frameIdMobile');

export const selectAccessoryId = createSelector(state => state.accessoryIdMobile);
export const setAccessoryId = createUpdateAction('accessoryIdMobile');

export const selectFrameIsDragging = createSelector(state => state.frameIsDragging);
export const setFrameIsDragging = createUpdateAction('frameIsDragging');

export const selectAccessoryIsDragging = createSelector(state => state.accessoryIsDragging);
export const setAccessoryIsDragging = createUpdateAction('accessoryIsDragging');

export const selectDraggedAccessory = createSelector(state => state.draggedAccessory);
export const setDraggedAccessory = createUpdateAction('draggedAccessory');